/**
 * Move — parallax scroll effect
 * ======================================
 * Activate: class="move"
 * Control:  data-move="-5"  (float, -10 to 10)
 *           positive = moves with scroll direction
 *           negative = moves against scroll (float up as page scrolls down)
 *
 * Options:
 *   data-move-mobile="2"          override speed on mobile (omit = same as desktop)
 *   data-move-transform="translateX(-50%)"
 *                                 preserve existing CSS transform — Move prepends
 *                                 this value so the element keeps its base position.
 *                                 Use when the element already has transform set via CSS.
 */

const DEFAULT_SPEED = 5
const FACTOR        = 0.02
const FACTOR_MOBILE = 0.01
const ISMOBILE      = window.matchMedia('(max-width: 768px)').matches

class Move {
    constructor() {
        this.elements = [...document.querySelectorAll('.move')]
        if (!this.elements.length) return

        this.factor  = ISMOBILE ? FACTOR_MOBILE : FACTOR
        this.ticking = false

        this.elements.forEach(el => el.style.willChange = 'transform')

        this.update()
        window.addEventListener('scroll', this.onScroll, { passive: true })
        window.addEventListener('resize', this.onResize, { passive: true })
    }

    onScroll = () => {
        if (this.ticking) return
        this.ticking = true
        requestAnimationFrame(() => {
            this.update()
            this.ticking = false
        })
    }

    onResize = () => {
        this.update()
    }

    update() {
        const vh     = window.innerHeight
        const center = vh / 2

        this.elements.forEach(el => {
            const rect = el.getBoundingClientRect()

            if (rect.bottom < -vh || rect.top > vh * 2) return

            const speedAttr = ISMOBILE && el.dataset.moveMobile !== undefined
                ? el.dataset.moveMobile
                : el.dataset.move

            const speed      = speedAttr !== undefined ? parseFloat(speedAttr) : DEFAULT_SPEED
            const elCenter   = rect.top + rect.height / 2
            const dist       = elCenter - center
            const translateY = dist * speed * this.factor
            const base       = el.dataset.moveTransform || ''

            el.style.transform = base
                ? `${base} translateY(${translateY.toFixed(2)}px)`
                : `translateY(${translateY.toFixed(2)}px)`
        })
    }
}

new Move()
